<template>
  <v-select
    :value="value"
    clearable
    :label="label"
    :items="years"
    :readonly="readonly"
    :rules="rules"
    :error-messages="errorMessages"
    menu-props="auto"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-select>
</template>

<script>
import { textLine } from '@/modules/_global/variables/rules';
import { generateYears } from '@/modules/holidays/common/utils';

export default {
  name: 'YearSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => textLine
    }
  },

  data() {
    return {
      years: []
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.years = generateYears();
    }
  }
};
</script>

<style scoped></style>
